module.exports = __webpack_public_path__ + "static/media/service-2.79cb816c.jpg";